import 'flatpickr/dist/themes/material_blue.css'

import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { values } from 'lodash'
import Switch from 'react-switch'

// Components
import ModalCodingTestRequired from 'app/views/components/Modals/Info/ModalCodingTestRequired'
import Loader from 'app/views/components/Loader'
import ModalOverrideOrganizationDefault from 'app/views/components/Modals/Info/ModalOverrideOrganizationDefault'

// Redux
import { getPlans } from 'app/state/modules/plan'
import { createTeam } from 'app/state/modules/team'

// Utils
import analytics from 'app/views/utils/analytics'
import OrganizationLayout from '../components/Layout'


class OrganizationsTeamsAdd extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: '',
      name: '',
      planId: '',
      hasSetInitialPlan: false,
      overrideMustPassCode: false,
      teamMustPassCode: false,
    }

    this.handleChangeName = this.handleChangeName.bind(this)
    this.handleChangePlan = this.handleChangePlan.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleOverrideEnabled = this.handleOverrideEnabled.bind(this)
    this.handleMustPassEnabled = this.handleMustPassEnabled.bind(this)
  }

  componentDidMount() {
    this.setState({ error: '', name: '', hasSetInitialPlan: false })
    this.props.getPlans(this.props.match.params.organization_uuid)

    analytics.page('page-organizations-teams-add')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.plans.length > 0 &&
      nextProps.plans !== this.props.plans &&
      this.state.hasSetInitialPlan === false
    ) {
      this.setState({ hasSetInitialPlan: true })
    }
    if (nextProps.creatingTeamError !== this.props.creatingTeamError) {
      this.setState({ error: nextProps.creatingTeamError })
    }
  }

  handleOverrideEnabled(active) {
    this.setState({
      overrideMustPassCode: active,
    })
  }

  handleMustPassEnabled(active) {
    this.setState({
      teamMustPassCode: active,
    })
  }

  handleChangeName(event) {
    this.setState({ name: event.target.value })
  }

  handleChangePlan(event) {
    this.setState({ planId: event.target.value })
  }

  handleSubmit(event) {
    event.preventDefault()

    if (this.state.name === '') {
      this.setState({ error: 'Name is required.' })
    } else {
      this.setState({ error: '' })
      this.props.createTeam(
        this.props.match.params.organization_uuid,
        this.state.name,
        this.state.planId === '' ? null : this.state.planId,
        this.state.overrideMustPassCode,
        this.state.teamMustPassCode,
      ).then((teamId) => {
        if (teamId) {
          this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/teams/${teamId}/users`)
        }
      })
    }
  }

  render() {
    if (this.props.plans.length === 0) {
      return <Loader visible />
    }
    return (
      <OrganizationLayout data-test-id="organizations-teams-component" currentOrganizationId={this.props.match.params.organization_uuid} {...this.props} active="teams">
        <div className="uk-padding-remove uk-width-expand@m uk-width-1-1@s" style={{ overflow: 'auto', height: 'calc(100vh - 80px)' }}>
          <div className="uk-padding" style={{ paddingLeft: 60 }} >
            <h1>Add Team</h1>

            <div className="uk-card uk-card-default uk-card-body">
              <div className="uk-container-small">
                <form className="uk-form-stacked">
                  <div className="uk-margin">
                    <label className="uk-form-label">Team Name</label>
                    <div className="uk-form-controls">
                      <input
                        className="uk-input"
                        type="text"
                        data-test-id="input-team-name"
                        placeholder=""
                        value={this.state.name}
                        onChange={this.handleChangeName}
                      />
                    </div>
                  </div>

                  <div className="uk-margin">
                    <div className="uk-inline">
                      <label
                        className="uk-form-label uk-inline"
                        style={{
                          display: 'inline-block',
                        }}
                      >
                        Assign Plan
                      </label>
                      <a
                        className="uk-inline"
                        href="#"
                        data-uk-icon="icon: info; ratio: 0.8"
                        data-uk-toggle="target: #modal-assign-plan"
                        style={{
                          marginLeft: 8,
                          marginBottom: 5,
                        }}
                      />
                    </div>
                    <div id="modal-assign-plan" data-uk-modal>
                      <div className="uk-modal-dialog uk-modal-body">
                        <h2>Assign Plan</h2>
                        <h4>Use Organization Default</h4>
                        <p>
                          Using the Organization Default plan does not actually
                          create a new plan for your team.  Instead, your team
                          will just use whatever the "Default Plan" has been
                          set to for your organization.
                        </p>
                        <h4>Select Preexisting Plan</h4>
                        <p>
                          Selecting an Organization or existing Team plan will
                          duplicate this plan for your new team. This allows you
                          to edit the plan that is created without editing the
                          original team's plan.
                        </p>
                        <p className="uk-text-right">
                          <button className="uk-button uk-button-primary uk-modal-close" type="button">
                            Ok
                          </button>
                        </p>
                        <button className="uk-modal-close-outside" type="button" data-uk-close />
                      </div>
                    </div>


                    <div className="uk-form-controls">
                      <select className="uk-select" id="add-teams-select-plan-clone" value={this.state.planId} onChange={this.handleChangePlan}>
                        <option value="">Use Organization Default</option>
                        {values(this.props.plans).map((plan) => {
                          if (!plan.uuid) return null
                          return (
                            <option key={plan.uuid} value={plan.uuid}>{plan.title} {plan.team_uuid ? `(Team ${plan.team_name})` : '(Organization Plan)'}</option>
                          )
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="uk-margin">
                    <label className="uk-form-label">Coding Test Required</label>
                    <div className="uk-inline">
                      <Switch
                        onChange={this.handleOverrideEnabled}
                        checked={this.state.overrideMustPassCode}
                        id="normal-switch"
                        offColor="#999999"
                        onColor="#1e87f0"
                        checkedIcon={false}
                        uncheckedIcon={false}
                      />
                      <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
                        Override Organization Default
                      </span>
                      <span
                        href="#"
                        data-uk-icon="icon: info; ratio: 0.8"
                        data-uk-toggle="target: #modal-info-override-organization-default"
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingTop: 6,
                          verticalAlign: 'top',
                        }}
                      />
                      <ModalOverrideOrganizationDefault />
                    </div>
                  </div>
                  {this.state.overrideMustPassCode && (
                    <div className="uk-margin">
                      <div
                        className="uk-inline"
                      >
                        <Switch
                          onChange={this.handleMustPassEnabled}
                          checked={this.state.teamMustPassCode}
                          id="normal-switch"
                          offColor="#999999"
                          onColor="#1e87f0"
                          checkedIcon={false}
                          uncheckedIcon={false}
                        />
                        <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
                          Coding Test Required
                        </span>
                        <span
                          data-uk-icon="icon: info; ratio: 0.8"
                          data-uk-toggle="target: #modal-info-coding-test-required"
                          style={{
                            cursor: 'pointer',
                            paddingLeft: 8,
                            paddingTop: 6,
                            verticalAlign: 'top',
                          }}
                        />
                        <ModalCodingTestRequired />
                      </div>
                    </div>
                  )}
                  {(this.state.error !== '') &&
                    <div className="uk-margin">
                      <p className="uk-text-danger" data-test-id="error-text">{this.state.error}</p>
                    </div>
                  }

                  {(this.props.creatingTeam) ? (
                    <div className="uk-margin">
                      <div data-uk-spinner="" />
                    </div>
                  ) : (
                      <div className="uk-margin">
                        <div className="uk-form-controls">
                          <button data-test-id="create-team-btn" className="uk-button uk-button-primary tm-button-default" onClick={this.handleSubmit}>Create Team</button>
                        </div>
                      </div>
                    )}

                </form>
              </div>
            </div>

          </div>
        </div>
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  // hacker
  organizations: state.hacker.organizationsList,

  // plans
  loadingPlans: state.plan.loadingPlans,
  hasLoadedPlans: state.plan.hasLoadedPlans,
  plans: state.plan.plans,
  organizationsHash: state.hacker.organizationsHash,

  // team
  creatingTeam: state.team.creatingTeam,
  creatingTeamError: state.team.creatingTeamError,
})
const mapDispatchToProps = (dispatch) => ({
  createTeam: (organizationId, name, planId, overRide, mustPassCode) => dispatch(createTeam(organizationId, name, planId, overRide, mustPassCode)),
  getPlans: (organizationId) => dispatch(getPlans(organizationId)),
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationsTeamsAdd))
